module.exports = __webpack_public_path__ + "img/Cotabato-Light__logo@2x.66eebd13.png";